var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapeUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "AREA_UNLOCK",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #AREA_UNLOCK .cls-1 {\n        opacity: 0.75;\n        mix-blend-mode: multiply;\n        isolation: isolate;\n      }\n\n      #AREA_UNLOCK .cls-2 {\n        fill: #3e4346;\n      }\n\n      #AREA_UNLOCK .cls-3, #AREA_UNLOCK .cls-5 {\n        fill: none;\n      }\n\n      #AREA_UNLOCK .cls-3 {\n        stroke: #3e4346;\n      }\n\n      #AREA_UNLOCK .cls-4 {\n        stroke: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.865,11.266H11.7V9.382A2.458,2.458,0,0,1,14.083,6.87a2.458,2.458,0,0,1,2.385,2.512h1.49A3.975,3.975,0,0,0,14.083,5.3a3.975,3.975,0,0,0-3.875,4.082v1.884H8.3V20.75H19.925V11.266ZM15.394,18.74H12.831l.417-2.638a1.792,1.792,0,0,1-.775-1.507,1.671,1.671,0,1,1,3.338,0,1.792,1.792,0,0,1-.775,1.507Z",
    transform: "translate(-2.075 -1.325)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 12,
    cy: 12,
    r: 11.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeUnlock);
export default __webpack_public_path__ + "static/media/shape-unlock.a3417d1c1432889fe6dc96728c9e720d.svg";
export { ForwardRef as ReactComponent };